/**
 * Client-side fallback messages.
 *
 * These are used only when the server sends no `message` at all, which happens
 * on 204 responses because RFC 9110 forbids a body, and on requests that fail
 * before reaching the server. A message coming from the server always wins.
 *
 * @type {Object<string, Object<string, string>>}
 */
const MESSAGES = {
  id: {
    empty: 'Data tidak ditemukan',
    bad_request: 'Permintaan tidak dapat diproses',
    unauthenticated: 'Sesi Anda telah berakhir, silakan login kembali.',
    forbidden: 'Anda tidak memiliki akses untuk melakukan operasi ini.',
    not_found: 'Data atau halaman yang dituju tidak ditemukan.',
    conflict: 'Data sudah ada atau sedang digunakan.',
    validation: 'Gagal memproses permintaan',
    server: 'Terjadi kesalahan pada sistem. Silakan coba beberapa saat lagi.',
    network: 'Koneksi gagal atau server tidak merespons.',
    timeout: 'Permintaan melebihi batas waktu. Silakan coba lagi.',
    canceled: 'Permintaan dibatalkan.',
    unknown: 'Terjadi kesalahan yang tidak diketahui.',
  },
  en: {
    empty: 'No data found',
    bad_request: 'The request could not be processed',
    unauthenticated: 'Your session has expired, please sign in again.',
    forbidden: 'You do not have permission to perform this operation.',
    not_found: 'The requested resource was not found.',
    conflict: 'The data already exists or is currently in use.',
    validation: 'Unable to process request',
    server: 'A system error occurred. Please try again shortly.',
    network: 'Connection failed or the server is not responding.',
    timeout: 'The request timed out. Please try again.',
    canceled: 'Request canceled.',
    unknown: 'An unknown error occurred.',
  },
};

/**
 * Looks up a fallback message.
 *
 * @param {string} language - Either `'id'` or `'en'`.
 * @param {string} key - Message key, usually an ERROR_KIND value.
 * @returns {string} The message, falling back to Indonesian and to `unknown`.
 */
export const fallbackMessage = (language, key) => {
  const catalog = MESSAGES[language] || MESSAGES.id;
  return catalog[key] || catalog.unknown;
};

export default MESSAGES;
